<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Igazolások előzménye – {{ nev || oktazon }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="bezar.emit()" aria-label="Bezárás">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ie-tartalom">
  <p class="ie-halvany ie-bevezeto">
    A tanév ({{ pontos(tanevKezd) }} – {{ pontos(tanevVege) }}) minden igazolási nyoma a hiányzás napja szerint
    időrendben: honnan jött és ki rögzítette. A „Napló” sor az órák mostani állapota; a „Napló-módosítás” az óra
    naplójából (2026. október 15. óta) mutatja, ki és mire változtatta az igazolást.
  </p>

  <div class="ie-forrasok" *ngIf="forrasok.length">
    <button type="button" *ngFor="let f of forrasok" class="ie-forras" [class.ki]="rejtett.has(f.kod)"
            [disabled]="!f.db" (click)="forrasValt(f.kod)" [title]="rejtett.has(f.kod) ? 'Megjelenítés' : 'Elrejtés'">
      {{ f.nev }} ({{ f.db }})
    </button>
  </div>

  <div *ngIf="betolt" class="ie-ures"><ion-spinner name="crescent"></ion-spinner> Betöltés…</div>
  <div *ngIf="!betolt && hiba" class="ie-hiba">{{ hiba }}</div>
  <div *ngIf="!betolt && !hiba && !lathato.length" class="ie-ures">Ebben a tanévben nincs igazolási bejegyzés.</div>

  <div class="ie-nap" *ngFor="let n of napok">
    <div class="ie-nap-fej">{{ pontos(n.datum) || 'dátum nélkül' }}</div>
    <div class="ie-tetel" *ngFor="let t of n.tetelek">
      <span class="ie-forras-cimke" [ngClass]="'ie-f-' + t.forras">{{ t.forras_nev }}</span>
      <span class="ie-tipus" [ngClass]="tipusSzin(t)">{{ t.tipus_nev || '–' }}</span>
      <span class="ie-statusz" *ngIf="t.statusz">{{ t.statusz }}</span>
      <span class="ie-orak" *ngIf="t.orak.length" [title]="orakCim(t)">{{ orakSzoveg(t) }}</span>
      <span class="ie-rogzito">
        <ng-container *ngIf="t.rogzito_nev || t.rogzito; else nincsRogzito">{{ t.rogzito_nev || t.rogzito }}</ng-container>
        <ng-template #nincsRogzito><span class="ie-halvany">rögzítő nem ismert</span></ng-template>
        <span class="ie-halvany" *ngIf="t.ido"> · {{ pontos(t.ido) }}</span>
      </span>
      <div class="ie-reszlet" *ngIf="t.hivatkozas || t.megjegyzes">
        <span *ngIf="t.hivatkozas">Hivatkozás: {{ t.hivatkozas }}</span><span *ngIf="t.hivatkozas && t.megjegyzes"> – </span>
        <span *ngIf="t.megjegyzes">{{ t.megjegyzes }}</span>
      </div>
    </div>
  </div>
</ion-content>
